import Swup from 'swup';
import Site from './site.js';
import Cart from './shop/cart.js';
import CartComponent from './shop/cartComponent.js';
import CartItem from './shop/cartItem';
import SwupScriptsPlugin from '@swup/scripts-plugin';

// import Splide from '@splidejs/splide';
import Alpine from 'alpinejs';
import Clipboard from "@ryangjchandler/alpine-clipboard"
import intersect from '@alpinejs/intersect'


const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const options = {
  plugins: [new SwupScriptsPlugin({
    optin: true
  })]
};

const swup = new Swup(options); 

// Events
swup.hooks.on("page:view", (visit) => {
  init();
});

Alpine.plugin(Clipboard);
Alpine.plugin(intersect);

// Start Apline after swup so it works correctly
window.Alpine = Alpine;

Alpine.data('site', Site);
Alpine.data('cart', CartComponent);
Alpine.data('cartitem', CartItem)
Alpine.store('cart', Cart);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
}